import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

// V9 - AgentAccountBillingDetailsService.js
export default class MLGatewayAccountBillingDetailsService {
    static getAccountBillingSummary(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getAccountBillingSummary', [accountNumber], additionalHeaders);
    }

    static getAccountBillingDetails(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getAccountBillingDetails', [accountNumber], additionalHeaders);
    }

    static getPaymentGroupPaymentInformation(accountNumber, groupId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getPaymentGroupPaymentInformation', [accountNumber, groupId], additionalHeaders);
    }

    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    static setPaymentGroupPaymentInformation(accountNumber, groupId, instrument, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'setPaymentGroupPaymentInformation', [accountNumber, groupId, instrument], additionalHeaders);
    }

    static getAccountPolicyPeriodsBillingSummary(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getAccountPolicyPeriodsBillingSummary', [accountNumber], additionalHeaders);
    }

    static getBillingDocumentsForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getBillingDocumentsForAccount', [accountNumber], additionalHeaders);
    }

    static getBillingDocumentsForPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getBillingDocumentsForPolicy', [policyNumber], additionalHeaders);
    }

    static getPaymentInstrumentsForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'getPaymentInstrumentsForAccount', [accountNumber], additionalHeaders);
    }

    static getBoAPaymentInstrumentsForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'getBoAPaymentInstruments', [accountNumber], additionalHeaders);
    }

    static getCCPaymentInstrumentsForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'getCreditCardPaymentInstruments', [accountNumber], additionalHeaders);
    }

    static usePaymentusACH(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'usePaymentusACH', [], additionalHeaders);
    }

    static getJpmcUrl(accountNumber, paymentMethod, redirectUrl, withSourceId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'getJpmcUrl', [accountNumber, paymentMethod, redirectUrl, withSourceId], additionalHeaders);
    }

    static getNewPaymentInstrumentUrl(accountNumber, paymentMethod, redirectUrl, preferredPaymentMethodInd, isSplUser = false, additionalHeaders = {}) {
        let promise = null;
        if (isSplUser) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getSecurePayLineUrl', [accountNumber, paymentMethod, 'sso-add-pm', null], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getNewPaymentInstrumentUrl', [accountNumber, paymentMethod, redirectUrl, preferredPaymentMethodInd], additionalHeaders);
        }
        return promise;
    }

    static getSplMakePaymentUrl(accountNumber, paymentMethod, bundledPaymentRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getSecurePayLineUrl', [accountNumber, paymentMethod, 'create-payment', bundledPaymentRequestDTO], additionalHeaders);
    }

    static editPaymentInstrument(accountNumber, paymentMethodInstrumentId, redirectUrl, paymentInstrumentType, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'editPaymentInstrument', [accountNumber, paymentMethodInstrumentId, redirectUrl, paymentInstrumentType], additionalHeaders);
    }

    static deletePaymentInstrument(accountNumber, paymentInstrumentId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'deletePaymentInstrument', [accountNumber, paymentInstrumentId], additionalHeaders);
    }

    static makePayment(bundledPaymentRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'makePayment', [bundledPaymentRequestDTO], additionalHeaders);
    }

    static makeBankAccountPayment(bundledPaymentRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'makeBankAccountPayment', [bundledPaymentRequestDTO], additionalHeaders);
    }

    static makeAgencySweepPayment(bundledPaymentRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'makeAgencySweepPayment', [bundledPaymentRequestDTO], additionalHeaders);
    }

    static addBankAccountPaymentInstrument(paymentDetails, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'createBankAccountInstrument', [paymentDetails], additionalHeaders);
    }

    static getBankAccountDetails(token, accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'getBankAccountDetails', [token, accountNumber], additionalHeaders);
    }

    static updateBankAccountDetails(bankAccountDetails, accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'updateBankAccountDetails', [bankAccountDetails, accountNumber], additionalHeaders);
    }

    static deleteBankAccountInstrument(paymentInstrumentId, accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billing'),
            'removeBankAccount', [paymentInstrumentId, accountNumber], additionalHeaders);
    }

    static getCCPermission(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
            'getCCPermission', [], additionalHeaders);
    }

    static searchPaymentsForProducer(searchParams, limit, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'searchPaymentsForProducer', [searchParams, limit], additionalHeaders);
    }

    static searchPaymentsForPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'searchPaymentsForPolicy', [policyNumber], additionalHeaders);
    }

    static voidOneTimePayment(publicId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'voidOneTimePayment', [publicId], additionalHeaders);
    };

    static voidBundledOneTimePayment(confirmationNumber, accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'),
            'voidBundledOneTimePayment', [confirmationNumber, accountNumber], additionalHeaders);
    };

    static setDocumentAsViewed(docId, token, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDocs'), 'setDocumentAsViewed',
            [docId, token], additionalHeaders)
    }
}
